module.exports = __webpack_public_path__ + "static/media/bici.5f52801d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/bici/bici.png
// module id = 330
// module chunks = 0